import hairlossfollowup from './Followup/hair-loss-followup';
import hairlossfollowupArchived from './Followup/hair-loss-followup-archived';
import hairlossMen from './Men/men-hair-loss';
import hairlossMenArchived from './Men/men-hair-loss-archived';
import hairlossWomen from './Women/women-hair-loss';
import unisexHairloss from './Unisex/unisex-hair-loss';
import hairlossPhotos from './HairlossPhotos/questions';

const HairLossQuestions = [
  ...hairlossfollowup,
  ...hairlossfollowupArchived,
  ...hairlossMen,
  ...hairlossMenArchived,
  ...hairlossWomen,
  ...unisexHairloss,
  ...hairlossPhotos
];
export default HairLossQuestions;
